/*document.addEventListener('DOMContentLoaded', function() {
  const conditionalTextElement = document.getElementById('conditional-text');
  if (conditionalTextElement) {
    const startDate = conditionalTextElement.getAttribute('data-start-date');
    const endDate = conditionalTextElement.getAttribute('data-end-date');

    const DateTime = luxon.DateTime;
    const now = DateTime.now().setZone('America/Mexico_City');

    // Función para convertir 'DD-MM-YYYY HH:mm' al objeto DateTime de Luxon
    function parseCustomDateFormat(dateStr) {
      const [datePart, timePart] = dateStr.split(' '); // Separa fecha y hora
      const [day, month, year] = datePart.split('-'); // Separa en día, mes, año
      const [hour, minute] = timePart.split(':'); // Separa hora y minutos
      // Retorna un DateTime con los valores desglosados en la zona horaria especificada
      return DateTime.fromObject({
        day: parseInt(day),
        month: parseInt(month),
        year: parseInt(year),
        hour: parseInt(hour),
        minute: parseInt(minute)
      }, { zone: 'America/Mexico_City' });
    }

    // Convertimos las fechas del formato 'DD-MM-YYYY HH:mm' a un objeto DateTime
    const startDateTime = parseCustomDateFormat(startDate);
    const endDateTime = parseCustomDateFormat(endDate);

    // Compara la fecha y hora actual con las fechas de inicio y fin
    if (!(now >= startDateTime && now <= endDateTime)) {
      // Si no está dentro del rango de fechas, removemos el texto
      conditionalTextElement.remove();
    }
  }
});*/

document.addEventListener('DOMContentLoaded', function () {
  // Seleccionamos todos los elementos con la clase .scheduled-promo-text
  const conditionalTextElements = document.querySelectorAll('.scheduled-promo-text');

  const DateTime = luxon.DateTime;
  const now = DateTime.now().setZone('America/Mexico_City');

  // Función para convertir 'DD-MM-YYYY HH:mm' al objeto DateTime de Luxon
  function parseCustomDateFormat(dateStr) {
    const [datePart, timePart] = dateStr.split(' '); // Separa fecha y hora
    const [day, month, year] = datePart.split('-'); // Separa en día, mes, año
    const [hour, minute] = timePart.split(':'); // Separa hora y minutos
    // Retorna un DateTime con los valores desglosados en la zona horaria especificada
    return DateTime.fromObject(
      {
        day: parseInt(day),
        month: parseInt(month),
        year: parseInt(year),
        hour: parseInt(hour),
        minute: parseInt(minute),
      },
      { zone: 'America/Mexico_City' }
    );
  }

  // Iteramos sobre cada elemento
  conditionalTextElements.forEach((element) => {
    const startDate = element.getAttribute('data-start-date');
    const endDate = element.getAttribute('data-end-date');

    // Convertimos las fechas del formato 'DD-MM-YYYY HH:mm' a un objeto DateTime
    const startDateTime = parseCustomDateFormat(startDate);
    const endDateTime = parseCustomDateFormat(endDate);

    // Compara la fecha y hora actual con las fechas de inicio y fin
    if (!(now >= startDateTime && now <= endDateTime)) {
      // Si no está dentro del rango de fechas, removemos el texto
      element.remove();
    }
  });
});